import { parse } from 'qs';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { openAutoUploadOnboadingDialog } from 'reactApp/sections/QuotaLanding/AutoUploadOnboardingDialog/AutoUploadOnboardingDialog.helpers';

export const useAutoUploadOnboardingFromQuery = () => {
    const { search } = useLocation();
    const queryParams = parse(search, { ignoreQueryPrefix: true });
    const isFromAction = queryParams?.action === 'request-autoupload';
    const { isLoaded } = useSelector(ProductsSelectors.getLifeCycleState);
    const isPaid = useSelector(UserSelectors.isPaidUser);
    const isCorp = useSelector(UserSelectors.isCorpUser);

    useEffect(() => {
        if (isFromAction && isLoaded && !isPaid && !isCorp) {
            openAutoUploadOnboadingDialog();
        }
    }, [isLoaded, isPaid, isCorp]);
};
